// extracted by mini-css-extract-plugin
export default {"Loader-circle":"styles_Loader-circle__cFwB6","dotCircle":"styles_dotCircle__OXMEO","pathCircle":"styles_pathCircle__RQf-s","Loader--wide":"styles_Loader--wide__pshWf"};